import bg_home from 'assets/images/bg_home.png';
import bg_home_mb from 'assets/images/bg_home_mb.png';
import HeaderMenu from 'components/Header/HeaderMenu';
import RightGif from 'components/RightGif';
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';
import MatchResult from './MatchResult';

const PrizeStructure = () => {
  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src={bg_home_mb}
        alt="Background"
        className="fixed top-0 left-0 h-full w-full object-cover object-top md:hidden"
      />
      <img
        src={bg_home}
        alt="Background"
        className="fixed top-0 left-0 hidden h-full w-full object-cover object-top md:block"
      />
      <RightGif />
      <div className="container relative z-10">
        <HeaderMenu />
        <MatchResult />
      </div>
    </div>
  );
};

export default PrizeStructure;
